/* eslint-disable no-console */
console.log( 'Hello World! (from create-block-footerflemi block)' );
/* eslint-enable no-console */
